import TaskVerbal  from './task-verbal';
import TaskNonVerbal  from './task-non-verbal';
import TaskQuantitative  from './task-quantitative';
import { getTestByVersion } from '../common/task-utility';

export const getTaskComponent = versionId => {
	const test = getTestByVersion(versionId);

	switch (test) {
		case 'Verbal':
			return TaskVerbal;
		
		case 'NonVerbal':
			return TaskNonVerbal;
		
		case 'Quant':
			return TaskQuantitative;
		
		default:
			return null;
	}
};